import { Id } from 'Common/Id';
import { ConnectionToServer } from 'Shared/Root';
import {createContext,JSX,mergeProps,useContext} from 'solid-js';
import { createStore, SetStoreFunction } from 'solid-js/store';

interface ISharedStore<D> {
	store: D;
	setStore: SetStoreFunction<D>;
	location: Location;
	afterUpdate?: (value:any,retValue:any) => Promise<void>;
	/* Only modifies the parent of the leaf, not anything higher. */
	prepare?: (previoues:any,field:string, value:any) => any;
}

export interface IDbStore<D> extends ISharedStore<D> {
	noDb?: false,
	server: ConnectionToServer;
	page: string;
	permission: string;
	docId: Id;
	imageFolder?: string;
}

export interface INoDbStore<D> extends ISharedStore<D> {
	noDb: true
}

export type IStoreWrap<D> = IDbStore<D> | INoDbStore<D>;


const StoreContext = createContext();

export function StoreProvider<D>(P:IStoreWrap<D> & {children:JSX.Element})
{
	return (
		<StoreContext.Provider value={P}>
			{P.children}
		</StoreContext.Provider>
	);
}

export interface ICreateStore<D> {
	initial: D;
	server: ConnectionToServer
	page: string;
	permission: string;
	docId: Id;
	location: Location;
	imageFolder?: string;
}

export function CreateStoreProvider<D>(P:ICreateStore<D> & {children:JSX.Element})
{
	const [store,setStore] = createStore(P.initial);

	const value = mergeProps(P,{
		store:store,
		setStore:setStore
	});

	return (
		<StoreContext.Provider value={value}>
			{P.children}
		</StoreContext.Provider>
	);
}

export function useStore<D>():IStoreWrap<D> 
{
	return useContext(StoreContext);
}

